import { client } from "utils";

export const getCountriesRequest = () => client.get("countries");
